import { createSlice } from '@reduxjs/toolkit';

import { CategoriesInitialStateProps } from '../types/categoriesTypes';
const name = 'categories';

const INITIAL_STATE: CategoriesInitialStateProps = {
  categories: [],
  currentCategory: null,
  isCategoriesLoading: false,
  isCategoryLoading: false,
  error: null,

  isCreateRequestLoading: false,
  isUpdateRequestLoading: false,
  isRemoveRequestLoading: false,
  isAssignRequestLoading: false,
};

const categoriesSlice = createSlice({
  name,
  initialState: INITIAL_STATE,
  reducers: {
    getCategories: state => {
      state.isCategoriesLoading = true;
    },
    getCategoriesSuccess: (state, action) => {
      state.isCategoriesLoading = false;
      state.categories = action.payload;
    },
    getCategoriesFailure: (state, action) => {
      state.isCategoriesLoading = false;
      state.error = action.payload;
    },
    getCategory: (state, action) => {
      state.isCategoryLoading = true;
    },
    getCategorySuccess: (state, action) => {
      state.isCategoryLoading = false;
      state.currentCategory = action.payload;
    },
    getCategoryFailure: (state, action) => {
      state.isCategoryLoading = false;
      state.error = action.payload;
    },
    createCategories: (state, action) => {
      state.isCreateRequestLoading = true;
    },
    createCategoriesSuccess: state => {
      state.isCreateRequestLoading = false;
    },
    createCategoriesFailure: (state, action) => {
      state.isCreateRequestLoading = false;
      state.error = action.payload;
    },

    updateCategories: (state, action) => {
      state.isUpdateRequestLoading = true;
    },
    updateCategoriesSuccess: state => {
      state.isUpdateRequestLoading = false;
    },
    updateCategoriesFailure: (state, action) => {
      state.isUpdateRequestLoading = false;
      state.error = action.payload;
    },

    removeCategories: (state, action) => {
      state.isRemoveRequestLoading = true;
    },
    removeCategoriesFailure: (state, action) => {
      state.isRemoveRequestLoading = false;
      state.error = action.payload;
    },
    removeCategoriesSuccess: state => {
      state.isRemoveRequestLoading = false;
    },

    assignCategories: (state, action) => {
      console.log("action: ", action)
      state.isAssignRequestLoading = true;
    },
    assignCategoriesFailure: (state, action) => {
      state.isAssignRequestLoading = false;
      state.error = action.payload;
    },
    assignCategoriesSuccess: state => {
      state.isAssignRequestLoading = false;
    },
  },
});

export const {
  getCategories,
  getCategoriesFailure,
  getCategoriesSuccess,

  getCategory,
  getCategorySuccess,
  getCategoryFailure,

  createCategories,
  createCategoriesSuccess,
  createCategoriesFailure,

  updateCategories,
  updateCategoriesSuccess,
  updateCategoriesFailure,

  removeCategories,
  removeCategoriesFailure,
  removeCategoriesSuccess,

  assignCategories,
  assignCategoriesFailure,
  assignCategoriesSuccess,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
